<template>
  <VueScriptComponent :script="input"></VueScriptComponent>
</template>

<script>
/* eslint-disable no-useless-escape */
import VueScriptComponent from 'vue-script-component';

export default {
  components: {
    VueScriptComponent,
  },
  name: "AnalysisIndex",
  computed:{
    input(){
        
        let first= `<div class="tradingview-widget-container">
        <div id="tradingview_a2229" style="height: 92vh !important;"></div>
        <div class="tradingview-widget-copyright"><a href="https://es.tradingview.com/symbols/NASDAQ-AAPL/" rel="noopener" target="_blank"><span class="blue-text">Technical Chart</span></a> by TradingView</div>
        <script type="text/javascript" src="https://s3.tradingview.com/tv.js"><\/script>
        <script type="text/javascript">
        new TradingView.widget(
        {
        "autosize": true,
        "symbol": "NASDAQ:AAPL",
        "interval": "D",
        "timezone": "Etc/UTC",
        "theme": "light",
        "style": "1",
        "locale": "${this.$i18n.locale}",
        "toolbar_bg": "#f1f3f6",
        "withdateranges": true,
        "hide_side_toolbar": false,
        "allow_symbol_change": true,
        "details": true,
        "calendar": true,
        "container_id": "tradingview_a2229"
      });
      <\/script>
      </div>`;
      return first;
    }
  }
}
</script>

<style scoped>

</style>
